import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Retourne le texte de la valeur de la propriété du product item dans la langue courante
 * Usage:
 *   property  | getProductItemPropertyValue : itemPropertyValueList
 * Example: "46L" devient "46 - Tall" ou "46 - Long" dépendamment de la langue
*/

@Pipe({
  name: 'getProductItemPropertyValue'
})

export class ProductItemPropertyValuePipe implements PipeTransform {

  constructor(private translateService: TranslateService,) {}

  transform(value: any, cvlValueList: any): string {
    // safety
    if (!value || !cvlValueList) return value;
    // get lang
    let local = this.translateService.currentLang.toLowerCase();
    // find value in cvlValueList
    let found = cvlValueList.find((item: any) => item.key.toLowerCase() === value.toLowerCase());
    if (found)
      return found.value[local];
    else
      return value;
  }
}